export const getDefaultState = () => {
  return {
    userList: [],
    roleList: [],
    roleDetails: {},
    userDetails: {},
    activitylogs: [],
    activityFilter: {},
    totalCount: 0,
    statisticsData: {},
    tenantGroupingList: null
  }
}
